import React,{ forwardRef, ReactNode } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface BlockWrapperProps {
    children: ReactNode;
    dashboard?: boolean;
    minHeight?: string | number;
    height?: string | number;
    sx?: SxProps<Theme>;
}

export const BlockWrapper = forwardRef<HTMLDivElement, BlockWrapperProps>(
    ({ children, dashboard = false, minHeight = '300px', height = '100%', sx }, ref) => {
        return (
            <Box
                ref={ref}
                className={!dashboard ? 'kedo-block' : undefined}
                sx={{
                    height,
                    marginBottom: '30px',
                    minHeight,
                    minWidth: '300px',
                    ...sx,
                }}
            >
                {children}
            </Box>
        );
    }
);

BlockWrapper.displayName = 'BlockWrapper';
